import React from 'react';

import config from '../../config';
import {RouteData} from '../types';
import {
  ORG_API_KEYS,
  ORG_BILLING,
  ORG_DASHBOARD,
  ORG_SERVICE_ACCOUNTS,
  ORG_SETTINGS,
  ORG_SETTINGS_PATHS,
  ORG_TEAMS,
  ORG_USER_ACTIVITY,
} from './orgPaths';

const IS_PRIVATE_ENV = config.ENVIRONMENT_IS_PRIVATE;

export const ORG_ROUTES_DATA: RouteData[] = [
  {
    additionalProps: {
      allowIframes: false,
      routeName: 'OrgDashboard',
    },
    condition: IS_PRIVATE_ENV,
    exact: true,
    isPrivateRoute: true,
    path: ORG_DASHBOARD,
    RouteComponent: React.lazy(
      () => import('../../pages/HomePage/HomePageWithData')
    ),
  },
  {
    additionalProps: {
      allowIframes: false,
      routeName: 'OrgTeams',
    },
    condition: IS_PRIVATE_ENV,
    exact: true,
    isPrivateRoute: true,
    path: ORG_TEAMS,
    RouteComponent: React.lazy(
      () => import('../../pages/HomePage/HomePageWithData')
    ),
  },
  {
    additionalProps: {
      allowIframes: false,
      routeName: 'OrgServiceAccounts',
    },
    condition: IS_PRIVATE_ENV,
    exact: true,
    isPrivateRoute: true,
    path: ORG_SERVICE_ACCOUNTS,
    RouteComponent: React.lazy(
      () => import('../../pages/HomePage/HomePageWithData')
    ),
  },
  {
    additionalProps: {
      allowIframes: false,
      routeName: 'OrgApiKeys',
    },
    condition: IS_PRIVATE_ENV,
    exact: true,
    isPrivateRoute: true,
    path: ORG_API_KEYS,
    RouteComponent: React.lazy(
      () => import('../../pages/HomePage/HomePageWithData')
    ),
  },
  {
    additionalProps: {
      allowIframes: false,
      routeName: 'OrgActivity',
    },
    condition: IS_PRIVATE_ENV,
    exact: true,
    isPrivateRoute: true,
    path: ORG_USER_ACTIVITY,
    RouteComponent: React.lazy(
      () => import('../../pages/HomePage/HomePageWithData')
    ),
  },
  {
    additionalProps: {
      allowIframes: false,
      routeName: 'OrgBilling',
    },
    condition: IS_PRIVATE_ENV,
    exact: true,
    isPrivateRoute: true,
    path: ORG_BILLING,
    RouteComponent: React.lazy(
      () => import('../../pages/HomePage/HomePageWithData')
    ),
  },
  {
    path: '/org/roles',
    redirect: ORG_SETTINGS,
  },
  {
    additionalProps: {
      allowIframes: false,
      routeName: 'OrgSettingsPage',
    },
    condition: IS_PRIVATE_ENV,
    exact: true,
    isPrivateRoute: true,
    path: ORG_SETTINGS_PATHS,
    RouteComponent: React.lazy(
      () => import('../../pages/HomePage/HomePageWithData')
    ),
  },
];
